































































import { Component, Mixins } from "vue-property-decorator";
import { Order } from "@foxone/api/src/models/defi";
import OrderActions from "defi/components/orders/OrderActions.vue";
import mixins from "@/mixins";
import utils from "defi/utils";

@Component({
  components: {
    OrderActions
  }
})
class OrderDetail extends Mixins(mixins.page) {
  loading = true;

  order: Order | null = null;

  get appbar(): any {
    return {
      title: this.$t("common.order.detail")
    };
  }

  get title() {
    return this.$t("common.order.detail") as string;
  }

  get id() {
    return this.$route.params.id as string;
  }

  get meta() {
    if (!this.order) {
      return {};
    }
    const status = utils.enums.getOrderStatusMeta(this.order.status);
    return {
      id: this.order.id,
      icon: this.order.pay_asset.icon,
      symbol: this.order.pay_asset.symbol.toUpperCase(),
      name: this.order.contract.name,
      quantity: this.order.pay_amount,
      statusText: this.$t(status.text),
      statusColor: status.color,
      createdAt: this.$common.utils.date.formatDate(+this.order.created_at * 1000, "YYYY/MM/DD HH:mm:ss")
    };
  }

  mounted() {
    this.loadData();
  }

  loadData() {
    this.requestOrderDetail();
  }

  async requestOrderDetail() {
    this.loading = true;
    const order = await this.$api.defi.getOrder(this.id);
    this.order = order;
    this.loading = false;
  }
}
export default OrderDetail;
